var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerScratchTurboIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89624 21.5635C3.77547 21.2005 3.77547 20.8082 3.89624 20.4452C6.32349 13.1425 13.2132 7.875 21.3332 7.875C29.4497 7.875 36.336 13.1373 38.7685 20.4365C38.891 20.7988 38.891 21.1908 38.7685 21.5548C36.343 28.8575 29.4532 34.125 21.3332 34.125C13.2167 34.125 6.32874 28.8627 3.89624 21.5635Z",
    stroke: "url(#paint0_linear_6578_38241)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.583 21C26.583 22.3924 26.0299 23.7277 25.0453 24.7123C24.0608 25.6969 22.7254 26.25 21.333 26.25C19.9406 26.25 18.6053 25.6969 17.6207 24.7123C16.6361 23.7277 16.083 22.3924 16.083 21C16.083 19.6076 16.6361 18.2723 17.6207 17.2877C18.6053 16.3031 19.9406 15.75 21.333 15.75C22.7254 15.75 24.0608 16.3031 25.0453 17.2877C26.0299 18.2723 26.583 19.6076 26.583 21Z",
    stroke: "url(#paint1_linear_6578_38241)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38241",
    x1: 9.61464,
    y1: 18.2727,
    x2: 37.4445,
    y2: 47.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6578_38241",
    x1: 17.823,
    y1: 19.9091,
    x2: 28.6615,
    y2: 28.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerScratchTurboIcon1);
export default __webpack_public_path__ + "static/media/jokerScratchTurboIcon1.6ec445bf6cbb473148979238a1e84dd1.svg";
export { ForwardRef as ReactComponent };